import React, { useEffect, useRef } from "react";
import Flatpickr from "react-flatpickr";
import { useGlobalStateStore } from "../stores/store";

const DatePicker = () => {
  const fpRef = useRef(null);
  const date = useGlobalStateStore((state) => state.filter.date);
  const setDate = useGlobalStateStore((state) => state.setDate);
  const { filterOpen } = useGlobalStateStore(); // Access filterOpen state

  const onChange = (value) => {
    setDate(value[0]);
  };

  const addCustomButtons = (instance) => {
    const buttonContainer = document.createElement("div");
    buttonContainer.className = "flatpickr-footer";

    const todayButton = document.createElement("button");
    todayButton.type = "button";
    todayButton.className = "flatpickr-btn-today";
    todayButton.innerText = "Today";
    todayButton.addEventListener("click", () => {
      instance.setDate(new Date());
      instance.close();
    });

    const cancelButton = document.createElement("button");
    cancelButton.type = "button";
    cancelButton.className = "flatpickr-btn-cancel";
    cancelButton.innerText = "Cancel";
    cancelButton.addEventListener("click", () => {
      instance.clear();
      instance.close();
    });

    const doneButton = document.createElement("button");
    doneButton.type = "button";
    doneButton.className = "flatpickr-btn-done";
    doneButton.innerText = "Done";
    doneButton.addEventListener("click", () => {
      instance.close();
    });

    buttonContainer.appendChild(todayButton);
    buttonContainer.appendChild(cancelButton);
    buttonContainer.appendChild(doneButton);
    instance.calendarContainer.appendChild(buttonContainer);
  };

  // Reset Flatpickr input value when date is cleared from store
  useEffect(() => {
    if (filterOpen && fpRef.current && !date) {
      fpRef.current.flatpickr.clear();
    }
  }, [date, filterOpen]);

  // Do not render Flatpickr unless filter panel is open
  if (!filterOpen) {
    return (
      <div>
        <label htmlFor="datepicker">Date</label>
        <div className="input__wrap">
          <input
            id="datepicker"
            className="input-styles"
            placeholder="Select"
            disabled
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      <label htmlFor="datepicker">Date</label>
      <div className="input__wrap">
        <Flatpickr
          ref={fpRef}
          id="datepicker"
          className="input-styles"
          placeholder="Select"
          options={{
            dateFormat: "D, d M Y",
            locale: {
              firstDayOfWeek: 1,
            },
            disableMobile: true,
            onReady: function (selectedDates, dateStr, instance) {
              addCustomButtons(instance);
              let wasInputClicked = false;
              const inputElement = instance.input;

              inputElement.addEventListener("click", () => {
                if (instance.isOpen && wasInputClicked) {
                  instance.close();
                } else {
                  wasInputClicked = true;
                }
              });

              instance.calendarContainer.addEventListener("mousedown", () => {
                wasInputClicked = false;
              });

              instance.config.onClose.push(() => {
                wasInputClicked = false;
              });
            },
            onOpen: function (selectedDates, dateStr, instance) {
              if (
                !instance.calendarContainer.querySelector(".flatpickr-footer")
              ) {
                addCustomButtons(instance);
              }
            },
          }}
          value={date || null}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default DatePicker;
